<template>
  <a-layout class='index animated fadeIn s_bf'>
    <SmallSquare content='可禁用和启用会员任务，启用后用户可通过完成任务赢取奖励。' :padding='true'></SmallSquare>
    <a-card :bordered="false">
      <a-button type="primary" v-has:memberTaskAdd="()=> {$router.push('/members/memberTask/userTaskAdd?type=add')}">添加任务</a-button>
      <div class='m-t-20'>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
          <template v-slot:reward="{ record }">
            <span class="m-r-5">{{record.reward}}积分</span>
          </template>
          <template v-slot:vip_data="{ record }">
            <div class="vipBox" v-if='record.vip_data.length'>
              <template v-for='item in record.vip_data' :key='item'>
                <span>{{item.vip_name}}</span>
                <span class="bd">、</span>
              </template>
            </div>
            <span v-else>全部等级</span>
          </template>
          <template v-slot:action="{ record }">
                <a-button type="primary" v-has:memberTaskStatus="()=>status(record)" class="m-r-5">{{record.status ? '禁用':'启用'}}</a-button>
                <a-button type="primary" v-has:memberTaskEdit="()=> {$router.push('/members/memberTask/userTaskEdit?type=edit&id='+record.id)}" class="m-r-5">编辑</a-button>
                <a-button danger v-has:memberTaskDel="()=>del(record)" class="m-r-5">删除</a-button>
          </template>
        </a-table>
      </div>
    </a-card>
  </a-layout>
</template>
<script>
  import {  DownOutlined } from "@ant-design/icons-vue";
  import { message } from 'ant-design-vue';
  import { inject, reactive, ref, toRefs } from "vue";
  import { getIntegralList, getIntegralState, getIntegralDel } from '@/api/assets'
  import { iscode } from '@/utils/app';
  export default {
    name: "",
    components: {  },
    setup() {
      const state = reactive({
        listLoading: false,
      });
      let data = ref();
      const $Modal = inject('$Modal')
      let columns = [
        {
          title: "任务名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "任务类型",
          dataIndex: "task_type_text",
          key: "task_type_text"
        },
        {
          title: "任务频次",
          dataIndex: "reward_num_text",
          key: "reward_num_text",
        },
        {
          title: "任务每次奖励",
          dataIndex: "reward",
          key: "reward",
          slots: { customRender: "reward" },
        },
        {
          title: "适用会员",
          dataIndex: "vip_data",
          key: "vip_data",
          slots: { customRender: "vip_data" },
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          customRender: ({ record }) => {
            return record.status ? '已启用' : '已禁用'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        }
      ];
      // 获取列表
      const initData = async () => {
        state.listLoading = true;
        let res = await getIntegralList().then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data;
        }
        state.listLoading = false;
      };
      initData();
      // 任务状态更改
      const status = (e) => {
        $Modal.confirm({
          centered: true,
          title: e.status ? '禁用任务' : '启用任务',
          content: e.status ? '禁用后用户将无法通过做该任务获取奖励，确定要继续吗？' : '确定要启用该任务吗？', onOk: async () => {
            let res = await getIntegralState({ id: e.id, status: e.status ? 0 : 1 }).then(res => res.data);
            if (iscode(res, true)) {
              initData();
            }
          }
        })
      }
      // 任务删除
      const del = (e) => {
        $Modal.confirm({
          centered: true,
          title: '确认删除会员任务？',
          content: '删除后该会员任务将无法恢复，您确定要删除该会员任务吗？', 
          onOk: async () => {
            let res = await getIntegralDel({ id: e.id}).then(res => res.data);
            if (iscode(res, true)) {
              initData();
            }
          }
        })
      }
      return {
        ...toRefs(state),
        data,
        columns,
        status,
        del
      };
    },
  };
</script>
<style>
  .vipBox .bd:last-child{display: none;}
</style>